import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { SCREEN_ID_APPLICATION_START } from 'client/constants/screenIds';

import {
  findHouseholdApplication,
} from 'common/householdApplication/applicationHelpers';

import {
  HOUSEHOLD_APPLICATION_CATEGORY_HOUSEHOLD_APPLICATION,
} from 'common/householdConstants';

import ListingActions from 'client/actions/Listing';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import BackButton from 'client/components/BackButton';
import SrApplicationButton from 'client/components/SrApplicationButton';
import SrInviteRoommateBlock from 'client/components/SrInviteRoommateBlock';
import Navbar from 'client/components/Navbar';

import branch from 'client/core/branch';

@withTransitionHook
@withScreenId(SCREEN_ID_APPLICATION_START)
@branch({
  currentUser: ['currentUser'],
  householdApplications: ['householdApplications'],
  listing: ['listing'],
})
@withScrollToTop
class ApplicationStartPage extends Component {
  static fetchData(match, inject) {
    return ListingActions.getById(inject, parseInt(match.params.listingId, 10));
  }

  static getPageMetadata = () => ({
    pageTitle: 'Application | Sunroom Rentals',
    section: 'Schedule Showing',
  })

  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    householdApplications: PropTypes.array,
    listing: PropTypes.object,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
  }

  _onBack = () => {
    const {
      history,
      match: {
        params: {
          listingId,
        },
      },
    } = this.props;

    history.push(`/listing/${listingId}`);
  }

  render() {
    const {
      currentUser,
      householdApplications,
      listing,
      match,
    } = this.props;

    const householdApplication = findHouseholdApplication({
      listingId: parseInt(match.params.listingId, 10),
      category: HOUSEHOLD_APPLICATION_CATEGORY_HOUSEHOLD_APPLICATION,
      householdApplications: householdApplications,
    });

    if (!householdApplication || currentUser.id !== parseInt(match.params.userId, 10)) {
      return (
        <Redirect to={`/listing/${match.params.listingId}`} />
      );
    }

    return (
      <div className='page-application-intro'>
        <Navbar
          leftButton={(
            <BackButton
              onClick={this._onBack}
            />
          )}
        />
        <div className='modal'>
          <div className='contentContainer'>
            <div className='stepsContainer'>
              <div className='step'>
                <span className='headline'>Start Application</span>
                <span className='bodyText'>
                  Everyone (over 18) living at the property needs to fill out this secure application.
                </span>
              </div>

              <div className='step'>
                <span className='headline'>Upload Documents</span>
                <span className='bodyText'>
                  Upload photos of your Government ID, paychecks, and other important docs.
                </span>
              </div>

              <div className='step'>
                <span className='headline'>Pay Application Fee</span>
                <span className='bodyText'>
                  Pay the landlord a non-refundable fee for each application submitted.
                </span>
              </div>
            </div>

            {listing && (
              <div>
                <SrApplicationButton
                  listing={listing}
                />
                <SrInviteRoommateBlock
                  currentUser={currentUser}
                  listing={listing}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

ApplicationStartPage.displayName = 'ApplicationStartPage';

export default ApplicationStartPage;
